// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#waiter-family-edit[data-v-46541fae]{max-width:600px;margin-left:auto;margin-right:auto}#waiter-family-edit .cancel-btn[data-v-46541fae],#waiter-family-edit .register-btn[data-v-46541fae]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
